import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import './Input.css';

/**
 * Input — champ de formulaire universel
 *
 * @param {string} label      - libellé affiché au-dessus
 * @param {string} hint       - texte d'aide sous le champ
 * @param {string} error      - message d'erreur (remplace hint)
 * @param {node}   leftIcon   - icône à gauche (FontAwesome class ou JSX)
 * @param {node}   rightIcon  - icône à droite
 * @param {string} size       - 'sm' | 'md' | 'lg'
 */
const Input = ({
  label,
  type        = 'text',
  name,
  value,
  onChange,
  placeholder,
  error,
  hint,
  required,
  disabled,
  autoComplete,
  leftIcon,
  rightIcon,
  size        = 'md',
  className   = '',
  ...rest
}) => {
  const hasError = Boolean(error);

  return (
    <div className={['input-group', className].filter(Boolean).join(' ')}>
      {label && (
        <label htmlFor={name} className="input-label">
          {label}
          {required && <span className="input-required" aria-hidden="true">*</span>}
        </label>
      )}

      <div className={[
        'input-wrapper',
        `input-wrapper--${size}`,
        hasError        ? 'input-wrapper--error'    : '',
        disabled        ? 'input-wrapper--disabled'  : '',
        leftIcon        ? 'input-wrapper--has-left'  : '',
        rightIcon       ? 'input-wrapper--has-right' : '',
      ].filter(Boolean).join(' ')}>

        {leftIcon && (
          <span className="input-icon input-icon--left" aria-hidden="true">
            {leftIcon}
          </span>
        )}

        <input
          id={name}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          autoComplete={autoComplete}
          aria-invalid={hasError}
          aria-describedby={
            error ? `${name}-error` : hint ? `${name}-hint` : undefined
          }
          {...rest}
        />

        {rightIcon && (
          <span className="input-icon input-icon--right" aria-hidden="true">
            {rightIcon}
          </span>
        )}
      </div>

      {error && (
        <span id={`${name}-error`} className="input-message input-message--error" role="alert">
          <ExclamationCircleIcon style={{ width: 18, height: 18, flexShrink: 0 }} aria-hidden="true" />
          {error}
        </span>
      )}
      {!error && hint && (
        <span id={`${name}-hint`} className="input-message input-message--hint">
          {hint}
        </span>
      )}
    </div>
  );
};

export default Input;
